import React, { useState, useEffect } from 'react';
import { Typography, Button, Paper } from '@mui/material';
import { alpha } from '@mui/material/styles';
import AdminService from '../../services/AdminService';
import FullScreenLoader from './FullScreenLoader';

const ImpersonationBanner = () => {
    const [impersonationStatus, setImpersonationStatus] = useState(null);
    const [exiting, setExiting] = useState(false);

    useEffect(() => {
        const checkStatus = async () => {
            try {
                const status = await AdminService.checkImpersonation();
                setImpersonationStatus(status);
            } catch (error) {
                // If the user is not logged in or other error, we just don't show the banner
                // console.error("Failed to check impersonation status", error);
            }
        };

        checkStatus();

        // Listen for impersonation events (start/stop) to re-check status
        window.addEventListener('impersonation-check', checkStatus);
        return () => {
            window.removeEventListener('impersonation-check', checkStatus);
        };
    }, []);

    if (!impersonationStatus || !impersonationStatus.isImpersonation) {
        return null;
    }



    const handleExit = async () => {
        try {
            setExiting(true);
            await AdminService.stopImpersonation();
            // Force reload to ensure clean session state
            window.location.href = "/admin";
        } catch (error) {
            console.error("Failed to stop impersonation", error);
            setExiting(false);
        }
    };

    return (
        <>
            <FullScreenLoader open={exiting} message="Restoring Identity..." />
            <Paper
                elevation={4}
                sx={{
                    position: 'relative',
                    zIndex: 2000,
                    backgroundColor: (theme) => theme.palette.warning.main,
                    color: 'white',
                    p: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 2,
                    borderRadius: 0
                }}
            >
                <Typography variant="body1" fontWeight="bold">
                    You are currently viewing this page as '{impersonationStatus.impersonatedEmail || 'user'}'
                </Typography>
                <Button
                    variant="contained"
                    size="small"
                    onClick={handleExit}
                    sx={{
                        backgroundColor: 'white',
                        color: (theme) => theme.palette.error.main,
                        '&:hover': {
                            backgroundColor: (theme) => alpha(theme.palette.error.main, 0.1),
                        }
                    }}
                >
                    Exit View
                </Button>
            </Paper>
        </>
    );
};

export default ImpersonationBanner;
